import { cn } from "../../utils/common/cn";
import React from "react";

interface ScreenHeaderProps {
  title: string;
  question: string;
  className?: string;
}

export function ScreenHeader({ title, question, className }: ScreenHeaderProps) {
  return (
    <div className={cn("mb-6", className)}>
      <h1 className="text-2xl font-bold text-foreground">{title}</h1>
      <p className="text-primary text-lg font-medium mt-1">"{question}"</p>
    </div>
  );
}
